import ConnectWise from './components/ConnectWise';

export default {
	component: ConnectWise
};